<template>
  <div style="background: #f7f7f7;" class="course-page-section">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <div class="side-bar-widget first-widget">
            <h2 class="widget-title text-capitalize"><span>校企合作</span></h2>
            <div class="post-categori ul-li-block">
              <ul>
                <li :class="tabIndex == 0 ? 'cat-item isActive' : 'cat-item'" @click="tabIndex = 0">
                  <a href="javascript:void(0);">校企合作介绍</a>
                </li>
                <li :class="tabIndex == 1 ? 'cat-item isActive' : 'cat-item'" @click="tabIndex = 1">
                  <a href="javascript:void(0);">合作企业名单</a>
                </li>
                <li class="cat-item">
                  <a href="javascript:void(0);">优秀学生推荐</a>
                </li>
                <li class="cat-item">
                  <a href="javascript:void(0);">企业招聘信息</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-9" v-show="tabIndex == 0">
          <div class="xqhz-title">校企合作介绍</div>
          <div class="xqhz-content">校企合作是一种注重培养质量，注重在校学习与企业实践，注重学校与企业资源、信息共享的“双赢”模式。校企合作做到了应社会所需，与市场接轨，与企业合作，实践与理论相结合的全新理念，为教育行业发展带来了一片春天。2017年10月18日，习近平同志在十九大报告中指出，优先发展教育事业。要全面贯彻党的教育方针，落实立德树人根本任务，发展素质教育，推进教育公平，培养德智体美全面发展的社会主义建设者和接班人。推动城乡义务教育一体化发展，高度重视农村义务教育，办好学前教育、特殊教育和网络教育，普及高中阶段教育，努力让每个孩子都能享有公平而有质量的教育。完善职业教育和培训体系，深化产教融合、校企合作。加快一流大学和一流学科建设，实现高等教育内涵式发展。健全学生资助制度，使绝大多数城乡新增劳动力接受高中阶段教育、更多接受高等教育。支持和规范社会力量兴办教育。加强师德师风建设，培养高素质教师队伍，倡导全社会尊师重教。办好继续教育，加快建设学习型社会，大力提高国民素质。</div>
          <div class="xqhz-title">合作企业</div>
          <div class="qy-list">
            <img src="@/assets/img/xqhz/xqhz_10.png" />
            <img src="@/assets/img/xqhz/xqhz_1.png" />
            <img src="@/assets/img/xqhz/xqhz_3.png" />
            <img src="@/assets/img/xqhz/xqhz_4.png" />
            <img src="@/assets/img/xqhz/xqhz_5.png" />
            <img src="@/assets/img/xqhz/xqhz_6.png" />
            <img src="@/assets/img/xqhz/xqhz_7.png" />
            <img src="@/assets/img/xqhz/xqhz_8.png" />
            <img src="@/assets/img/xqhz/xqhz_11.png" />
          </div>
          <div class="xqhz-more" @click="tabIndex = 1">查看全部企业<img src="@/assets/img/xqhz/more.png" /></div>
        </div>
        <div class="col-md-9" v-show="tabIndex == 1">
          <div class="xqhz-title">合作企业名录</div>
          <div class="xqhz-table">
            <table>
              <tr>
                <th>序号</th>
                <th>企业名称</th>
                <th>2021年度业务</th>
              </tr>
              <tr>
                <td>1</td>
                <td>航达建设集团有限公司</td>
                <td>12.22万</td>
              </tr>
              <tr>
                <td>2</td>
                <td>昌建建设集团有限公司</td>
                <td>1.44万</td>
              </tr>
              <tr>
                <td>3</td>
                <td>江西泰邦园林建设有限公司</td>
                <td>0.36万</td>
              </tr>
              <tr>
                <td>4</td>
                <td>润邦控股集团有限公司</td>
                <td>2.61万</td>
              </tr>
              <tr>
                <td>5</td>
                <td>洪州建设集团有限公司</td>
                <td></td>
              </tr>
              <tr>
                <td>6</td>
                <td>江西金墨斗建设工程有限公司</td>
                <td>0.06万</td>
              </tr>
              <tr>
                <td>7</td>
                <td>南昌市第四建筑工程有限公司</td>
                <td>1.68万</td>
              </tr>
              <tr>
                <td>8</td>
                <td>江西昌贤建设集团有限公司</td>
                <td>0.73万</td>
              </tr>
              <tr>
                <td>9</td>
                <td>江西福乐园林有限责任公司</td>
                <td>1.40万</td>
              </tr>
              <tr>
                <td>10</td>
                <td>江西翰飞建设有限公司</td>
                <td>2.98万</td>
              </tr>
              <tr>
                <td>11</td>
                <td>洪城市政环境建设集团有限公司</td>
                <td></td>
              </tr>
              <tr>
                <td>12</td>
                <td>江西省机械建筑工程有限公司</td>
                <td>2.37万</td>
              </tr>
              <tr>
                <td>13</td>
                <td>江西磊天建设有限公司</td>
                <td>0.80万</td>
              </tr>
              <tr>
                <td>14</td>
                <td>红谷滩建设集团有限公司</td>
                <td>1.64万</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0
    }
  },

  created() {
  },

  mounted() {

  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
.container {
  .side-bar-widget .post-categori {
    background-color: #fff;
  }
  .isActive {
    color: #16cfd0;
  }
  .cat-item:hover {
    color: #16cfd0 !important;
  }
  .xqhz-title {
    font-size: 20px;
    margin-bottom: 30px;
    color: #333;
    font-weight: bold;
  }
  .xqhz-content {
    text-indent: 2em;
    margin-bottom: 35px;
    line-height: 24px;
  }
  .qy-list {
    display: flex;
    flex-wrap: wrap;
    img {
      width: auto;
      height: 64px;
      margin-right: 16px;
      margin-bottom: 16px;
    }
  }
  .xqhz-more {
    margin: 0 0 64px 0px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: #333;
    font-weight: bold;
    cursor: pointer;
    font-size: 14px;
    img {
      width: 14px;
      height: 14px;
      margin-left: 2px;
    }
  }
  .xqhz-table {
    margin-bottom: 80px;
    table {
      border: 1px solid #e1e1e1;
      border-collapse: collapse;
      th,
      td {
        border: 1px solid #e1e1e1;
        border-collapse: collapse;
        padding: 0;
        line-height: 50px;
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/xqhz.vue